import axios from "axios";
import CryptoJS from "crypto-js";

export const getConfigFromParamStore = async () => {
  sessionStorage.removeItem("urlsData")
  return new Promise(async (resolve, reject) => {
    try {
     
      const response = await axios.post("/api/frontendConfig", {});
      if (response.status === 200) {
        let encryptedUrlsData = response.data.response.payload.uiConfigParam
        sessionStorage.setItem("urlsData", JSON.stringify(encryptedUrlsData));
      }
      resolve(response);
    } catch (err) {
      reject({ err });
    }
  });
};

export const getConfigFromStroage = () => {
  let urlsData = sessionStorage.getItem("urlsData");
  if (urlsData) {
    return JSON.parse(urlsData);
  } else {
    return null;
  }
};

export const decryptedData = (data) => {
  let urlsData = getConfigFromStroage();
  const defaultEncryptionKey = urlsData["defaultEncryptionKey"];
  let key = defaultEncryptionKey
  let encryptedBase64Key = btoa(key);
  let parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
  let decryptedData = "";

  decryptedData = CryptoJS.AES.decrypt(data, parsedBase64Key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  // decryptedData = CryptoJS.AES.decrypt(data, parsedBase64Key, {
  //   mode: CryptoJS.mode.ECB,
  //   padding: CryptoJS.pad.Pkcs7,
  // });
  return CryptoJS.enc.Utf8.stringify(decryptedData).toString();
};
